import moment from 'moment'
import _ from 'lodash'

const tempArr = [
    {name: 'Operation Manager Desk', color: '#558f8f'},
    {name: 'Front Desk', color: '#faad14'},
    {name: 'Registration Desk', color: '#52c41a'},
    {name: 'Application Desk', color: '#13c2c2'},
    {name: 'Visa Desk', color: '#f759ab'},
    {name: 'Claim Desk', color: '#120338'},
    {name: 'Archive Desk', color: 'red'},
    {name: 'Dead Inquiry', color: 'red'}
]


const deskNameObj = {
    'Operation Manager Desk': 'Operation Manager Desk',
    'Front Desk': 'Counselling Desk',
    'Registration Desk': 'Registration Desk',
    'Application Desk': 'Application Desk',
    'Visa Desk': 'Visa Desk',
    'Claim Desk': 'Claim Desk',
    'Dead Inquiry': 'Dead Inquiry',
    'Archive Desk': 'Archive Desk'
}

const setting = {
    dateFormat: 'DD/MMM/YYYY',
    masterFormat: 'lll',
    getDateformatted: value => {
        return moment(value).format(setting.dateFormat)
    },
    deskNameObj: deskNameObj,
    allDesks: tempArr,
    deskColor: (desk) => {
        let findIn = _.find(tempArr, ((vv) => {
            return desk == vv.name
        }))
        if (findIn) {
            return findIn.color
        } else {
            return null
        }
    }
}

export default setting
